import * as MutationsTypes from './mutationsTypes';

const socialMediaList = (state, payload) => {
  state.socialMediaList = payload;
};

const createSocialMediaSuccess = (state, payload) => {
  state.createSocialMediaSuccess = payload;
};

const deleteSocialMediaSuccess = (state, payload) => {
  state.deleteSocialMediaSuccess = payload;
};

const updateSocialMediaSuccess = (state, payload) => {
  state.updateSocialMediaSuccess = payload;
};

export const mutations = {
  [MutationsTypes.SOCIAL_MEDIA_LIST]: socialMediaList,
  [MutationsTypes.CREATE_SOCIAL_MEDIA_SUCCESS]: createSocialMediaSuccess,
  [MutationsTypes.DELETE_SOCIAL_MEDIA_SUCCESS]: deleteSocialMediaSuccess,
  [MutationsTypes.UPDATE_SOCIAL_MEDIA_SUCCESS]: updateSocialMediaSuccess,
};
